import * as billboard from 'themes/billboard';
import * as canvas from 'themes/canvas';
import * as classic from 'themes/classic';
import * as energy from 'themes/energy';
import {
  BILLBOARD_THEME_TOKEN,
  CANVAS_THEME_TOKEN,
  ENERGY_THEME_TOKEN,
  ORGANIC_THEME_TOKEN,
  PLAY_THEME_TOKEN,
  ZEN_THEME_TOKEN,
} from 'themes/helpers';
import * as organic from 'themes/organic';
import * as playful from 'themes/playful';
import * as zen from 'themes/zen';

import { useAppContext } from 'hooks/context/useAppContext';

function getThemeElements(slug: string | undefined) {
  switch (slug) {
    case PLAY_THEME_TOKEN:
      return playful;
    case ORGANIC_THEME_TOKEN:
      return organic;
    case CANVAS_THEME_TOKEN:
      return canvas;
    case ZEN_THEME_TOKEN:
      return zen;
    case ENERGY_THEME_TOKEN:
      return energy;
    case BILLBOARD_THEME_TOKEN:
      return billboard;
    default:
      return classic;
  }
}

export enum ThemeModes {
  DARK = 'dark',
  LIGHT = 'light',
}

export const useGGTheme = () => {
  const { theme } = useAppContext();

  const { components, pages } = getThemeElements(theme?.token) || {};

  // This logic will be moved to backend: https://glossgenius.atlassian.net/browse/EN-15551
  const themeMode =
    theme?.palette?.name === 'Dark' ? ThemeModes.DARK : ThemeModes.LIGHT;

  return {
    theme,
    themeMode,
    components,
    pages,
  };
};
